var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"order-success-page"},[_c('div',{staticClass:"message-container"},[_c('h1',[_vm._v("Your order has been placed!")]),_c('p',[_vm._v("You will receive a confirmation e-mail once your order is ready to ship.")])])])
}]

export { render, staticRenderFns }